/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * Type of entity the file is associated with
 */
export enum GenerateUploadUrlDtoAssociatedEntityType {
  ANSWER = "ANSWER",
  USER = "USER",
  FOLLOW_UP_ACTION = "FOLLOW_UP_ACTION",
  COMPLIANCE_TASK_INSTANCE = "COMPLIANCE_TASK_INSTANCE",
}
